import Vue from 'vue'
import AcenadTransformer from '../../transformers/Files/acenadStampedInvoice'

export default (acenad, invoice) => {
  const tData = AcenadTransformer.send(acenad, invoice)

  return Vue.$http.post('/catalogs/common/file/', tData)
    .then((response) => {
      const data = response.data
      return data
    })
  .catch((err) => { throw err })
}


// WEBPACK FOOTER //
// ./src/services/Files/createAcenad.js